<template>
    <b-container fluid="true" v-if="selectedEfedros != null">
        <b-row class="justify-content-md-center">
            <b-col md="8">
                <h2>Επικαιροποίηση των ατομικών και σωματομετρικών στοιχείων</h2>
                <br>
                <b-card no-body>
                    <user-details-form :selected-efedros="selectedEfedros"
                                       :is-disabled="false"
                                       @update:success="success"
                                       @update:error="error"
                                       ref="form"
                    />
                </b-card>
                <br>
                <Message v-if="msgVisible" v-bind:msgClass="msgClass" v-bind:message="message"></Message>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center">
            <b-col md="8">
                    <b>Υπεύθυνη Δήλωση</b>
                    <br>
                    Τα στοιχεία που επικαιροποιούνται /δηλώνονται επέχουν θέση υπεύθυνης δήλωσης του αριθμού 8
                    του ν. 1599/86 και η ακρίβειά τους δύναται να ελεγχθεί από την Υπηρεσία. Μη ακρίβεια των
                    δηλουμένων στοιχείων επισύρει τις προβλεπόμενες από τον νόμο συνέπειες.
                    <br>
                    <br>
                    <div class="d-flex align-items-center justify-content-center mb-3">
                      <label class="mr-3 mb-0" for="accept">&nbsp;Αποδέχομαι</label>
                      <b-form-checkbox
                          id="accept"
                          name="accept"
                          value="accept"
                          v-model="isChecked"
                      class="ml-md-0">
  <!--                      Αποδέχομαι-->
                      </b-form-checkbox>

                    </div>
                <button type="submit" v-on:click.prevent="update" id="submitbtn" class="btn btn-success"
                        :disabled="!isChecked">
                    Ενημέρωση
                </button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import {HTTP} from "@/main";
import {Structs} from "@/structs"
import Message from '@/components/Message.vue'
import UserDetailsForm from "@/components/UserDetailsForm";

export default {
    name: "UserDetails",
    components: {
        Message,
        UserDetailsForm,
    },

    created() {
        if (!this.$store.getters.getToken) this.$router.push('login');
        if (this.$store.getters.userRole !== "ROLE_USER") this.$router.push('home');

        this.$bvToast.toast('Η συμπλήρωση όλων των παρακάτω στοιχείων είναι υποχρεωτική.', {
            title: `Στοιχεία Χρήστη`,
            autoHideDelay: 10000,
            variant: 'success',
            solid: true
        });

    },

    mounted() {
        this.init();
    },

    data: function () {
        return {
            selectedEfedros: null,
            message: '',
            msgVisible: false,
            msgClass: '',
            isChecked: false
        };
    },
    methods: {
        init: function () {
            var efsa = this.$store.getters.efsa;
            this.$store.dispatch("loading");
            let url = "/users/" + efsa;

            HTTP.get(url)
                .then(response => {
                    this.selectedEfedros = response.data;
                    this.$store.commit("setEmail", this.selectedEfedros.user.email)
                    if (this.selectedEfedros.afm == null) {
                        this.selectedEfedros.afm = Structs.Afm();
                    }
                    if (this.selectedEfedros.swmatometrika == null) {
                        this.selectedEfedros.swmatometrika == Structs.Swmatometrika();
                    }
                    this.$store.dispatch("stop_loading");
                })
                .catch(error => {
                    console.error(error);
                    this.$store.dispatch("stop_loading");
                });
        },
        update: function () {
            this.$refs.form.update()
        },
        success: function (event) {
            this.setMsg('success', event);
            this.init()
        },
        error: function (event) {
            this.setMsg('danger', event)
        },
        setMsg(status, msg) {
            this.message = msg;
            this.msgClass = status;
            this.msgVisible = true;
        },
    },
}
</script>

<style scoped>
ul.topoi_list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.topoi_list li {
    border: 1px solid #ced4da;
    border-radius: 3px;
    margin-top: 2px;
}

.topoi_list li:hover {
    cursor: pointer;
    color: #fff;
    background: rgba(0, 114, 198);
}

/* Force scrollbars onto browser window */
body {
    margin-bottom: 200%;
}

/* Box styles */
.myBox {
    border: none;
    padding: 5px;
    font: 18px/27px sans-serif;
    /* width: 90%; */
    height: 200px;
    /* overflow-y: scroll; */
    position: relative;
    top: 10%;
}

/* Scrollbar styles */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    border: 1px solid #0072C6;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: #0072C6;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgb(1, 79, 134);
}
</style>